import {maxZipFileSizeInMegabytes} from "../../infrastructure/config";

export const validateFileInput = (fileList: FileList) => {
  const file = fileList?.[0];

  if (!file) {
    return true;
  }

  if (!file.name?.toLowerCase().endsWith(".zip")) {
    return "File should have a .zip extension";
  }

  if (file.size > fileSizeInBytes(maxZipFileSizeInMegabytes)) {
    return `File should not be bigger than ${maxZipFileSizeInMegabytes} megabytes`;
  }

  return true;
};

export const fileSizeInBytes = (size: number) => size * megabyteMultiplier;

export const megabyteMultiplier = 1024 * 1024;
